import { useProfile, useWorkspaceStore } from '@shared/state';
import { BrandMark } from '@shared/ui';
import { MissionSelector } from './components/MissionSelector';
import { useToolOnboarding } from '@modules/onboarding';
import { useSyncStatus } from '@shared/sync';
import { Link } from 'react-router-dom';

export function Topbar() {
  const profile = useProfile();
  const updateProfile = useWorkspaceStore((state) => state.updateProfile);
  const { currentConfig, open: openGuide } = useToolOnboarding();
  const syncStatus = useSyncStatus();
  const isGuided = profile.mode === 'guided';
  const syncLabel = syncStatus.phase === 'error' || syncStatus.phase === 'conflict'
    ? 'Action requise'
    : syncStatus.source === 'cloud'
      ? 'Sauvegardé dans le cloud'
      : 'Sur cet appareil';
  const syncDate = syncStatus.lastSyncAt
    ? new Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }).format(syncStatus.lastSyncAt)
    : null;

  return (
    <header className="topbar">
      <div className="topbar-brand">
        <BrandMark
          profile={profile}
          size="sm"
          className="topbar-brandmark"
          label={profile.company || 'INDXONE'}
        />
        <div className="topbar-brandcopy">
          <strong>{profile.company?.trim() || 'INDXONE Hub'}</strong>
        </div>
      </div>

      <div className="topbar-center">
        <MissionSelector />
      </div>

      <div className="topbar-mode">
        <span className="topbar-mode-label">Mode</span>
        <div className="topbar-mode-switch" role="group" aria-label="Mode de navigation">
          <button
            type="button"
            className={`topbar-mode-btn ${isGuided ? '' : 'active'}`}
            aria-pressed={!isGuided}
            onClick={() => updateProfile({ mode: 'expert' })}
          >
            Expert
          </button>
          <button
            type="button"
            className={`topbar-mode-btn ${isGuided ? 'active' : ''}`}
            aria-pressed={isGuided}
            onClick={() => updateProfile({ mode: 'guided' })}
          >
            Guidé
          </button>
        </div>
      </div>

      <div className="topbar-actions">
        {syncStatus.phase === 'conflict' ? (
          <Link
            to="/tools/profile#cloud-conflict"
            className={`topbar-sync-status topbar-sync-status--${syncStatus.phase}`}
            title={syncStatus.message}
            aria-live="polite"
          >
            {syncLabel}{syncDate ? ` · ${syncDate}` : ''}
          </Link>
        ) : (
          <span
            className={`topbar-sync-status topbar-sync-status--${syncStatus.phase}`}
            title={syncStatus.message}
            aria-live="polite"
          >
            {syncLabel}{syncDate ? ` · ${syncDate}` : ''}
          </span>
        )}
        {currentConfig && (
          <button type="button" className="topbar-btn topbar-btn-guide" onClick={openGuide}>
            <span className="topbar-btn-guide-icon" aria-hidden="true">?</span>
            <span className="topbar-btn-label">Guide</span>
          </button>
        )}
      </div>
    </header>
  );
}
